document.addEventListener("DOMContentLoaded", function () {
  const LIVE_THEME_ID = 137800581190;

  function run() {
    if (!window.Shopify?.theme?.id) return false;
    const themeId = window.Shopify.theme.id;
    if (themeId === LIVE_THEME_ID || themeId === LIVE_THEME_ID.toString()) {
      return true;
    }
    const headers = document.querySelectorAll("main-header");
    headers.forEach(function (header, key) {
      if (key > 0) header.remove();
    });
    return true;
  }

  if (run()) return;
  let attempts = 0;
  const id = setInterval(function () {
    if (run() || ++attempts > 50) clearInterval(id);
  }, 100);
});
